import { __exports as e } from "../../../../../../../../../_virtual/email-template.js";
import "./html-block.js";
import { __exports as _ } from "../../../../../../../../../_virtual/html-block.js";
Object.defineProperty(e, "__esModule", {
  value: !0
});
e.EMAIL_TEMPLATE_CONFIG = void 0;
var t = _, r = Object.assign({}, t.HTML_BLOCK_CONFIG, {
  WHOLE_DOCUMENT: !0
});
e.EMAIL_TEMPLATE_CONFIG = r;
export {
  e as default
};
